import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined';
import { GridColDef } from '@mui/x-data-grid-pro';

import type { FeatureChecker } from 'common/src/features/FeatureChecker';
import { ProductFeatures } from 'common/src/types/enums/ProductFeatures.enum';
import { IAccount, IFacility, IMeter } from 'common/src/types/interfaces';

import { isActiveMeter } from 'portal/src/utils/checkActive';

import addBooleanColumnProps from '../../common/tables/addBooleanColumnProps';
import addDateColumnProps from '../../common/tables/addDateColumnProps';
import { masterSubMeterColumn } from '../../common/tables/masterSubColumns';

const buildAssociatedMetersColumns = (
  form: 'account' | 'facility',
  featureChecker: FeatureChecker,
): GridColDef[] => [
  {
    field: 'isActive',
    headerName: 'Active',
    valueGetter: (_, row: IMeter) => isActiveMeter(row),
    ...addBooleanColumnProps({
      labels: {
        yesLabel: (
          <CheckCircleOutlineOutlinedIcon
            color="success"
            fontSize="small"
            aria-label="Active"
          />
        ),
        noLabel: (
          <DoDisturbOnOutlinedIcon
            color="action"
            fontSize="small"
            aria-label="Inactive"
          />
        ),
      },
      width: 90,
    }),
  },
  {
    field: 'name',
    headerName: 'Meter Name',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'replacesMeter',
    headerName: 'Replaces Meter',
    flex: 0.7,
    valueFormatter: (value: IMeter) => value?.name ?? '',
  },
  ...(form === 'account'
    ? [
        {
          field: 'parentFacility',
          headerName: 'Parent Facility',
          flex: 0.7,
          valueFormatter: (value: IFacility) => value?.name ?? '',
        },
      ]
    : [
        {
          field: 'parentAccount',
          headerName: 'Parent Account',
          flex: 0.7,
          valueFormatter: (value: IAccount) => value?.number ?? '',
        },
      ]),
  {
    field: 'serviceType',
    headerName: 'Service Type',
    flex: 0.7,
    maxWidth: 190,
  },
  {
    field: 'usageUnit',
    headerName: 'Usage Unit',
    flex: 0.7,
    maxWidth: 120,
  },
  {
    field: 'inactiveDate',
    ...addDateColumnProps('Inactive Date'),
  },
  ...(featureChecker.productFeatureEnabled(ProductFeatures.allocations)
    ? [masterSubMeterColumn]
    : []),
];

export default buildAssociatedMetersColumns;
